/* twin.beauty — Medien-Fallback
   Fuer jedes <video data-tb-video> im Container [data-tb-media]:
   - prefers-reduced-motion: Video nicht laden, Poster bleibt stehen
   - Ladefehler (error an video oder letzter source): Container bekommt
     .tb-media--failed, das Video wird ausgeblendet, das Poster (Attribut und
     Container-Hintergrund) bleibt dauerhaft sichtbar
   - Laeuft das Video nach 3 s noch nicht, bleibt einfach das Poster sichtbar
     (.tb-media--waiting); startet es spaeter, wird es normal eingeblendet.
     Es wird nie wegen langsamer Verbindung dauerhaft versteckt.
   Auch fuer Sections, die der Theme-Editor nachlaedt. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tryPlay(v) {
    try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }

  function init(v) {
    if (v.__tb) return; v.__tb = true;
    var box = v.closest('[data-tb-media]') || v.parentElement;

    if (reduce) {
      v.removeAttribute('autoplay');
      v.preload = 'none';
      try { v.pause(); } catch (e) {}
      v.querySelectorAll('source').forEach(function (s) { s.removeAttribute('src'); });
      if (v.hasAttribute('src')) v.removeAttribute('src');
      try { v.load(); } catch (e) {}
      if (box) box.classList.add('tb-media--static');
      return;
    }

    var ok = false;
    function fail() {
      if (ok) return;
      if (box) { box.classList.add('tb-media--failed'); box.classList.remove('tb-media--waiting'); }
    }
    v.addEventListener('playing', function () {
      ok = true;
      if (box) { box.classList.add('tb-media--playing'); box.classList.remove('tb-media--waiting'); box.classList.remove('tb-media--failed'); }
    });
    v.addEventListener('error', fail);
    var sources = v.querySelectorAll('source');
    if (sources.length) sources[sources.length - 1].addEventListener('error', fail);
    v.addEventListener('canplay', function () { if (!ok && v.paused) tryPlay(v); });
    v.addEventListener('stalled', function () { if (!ok) tryPlay(v); });

    setTimeout(function () { if (!ok && box) box.classList.add('tb-media--waiting'); }, 3000);
    if (v.autoplay) tryPlay(v);
  }

  function initAll(root) { (root || document).querySelectorAll('video[data-tb-video]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
